import React, { useEffect, useState } from "react";
import ReactQuill from "react-quill";
import { useSecureUpdateItem } from "../../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { useAtom } from "jotai";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { toast } from "react-toastify";
import CuSpinner from "../../../common_component/component/CuSpinner";
import { useNavigate } from "react-router-dom";
import { useItemsFilter } from "../../../_helper/actions/app/items";
import { IoFastFood } from "react-icons/io5";

const Disclaimer = () => {
  const [value, setValue] = useState("");
  const [clinic] = useAtom(clinicAtom);
  const navigate = useNavigate();

  const filter = `?action=getDoctorPersonalDetails&clinic_id=${clinic?.id}&backend=True&login=True`;
  const { data } = useItemsFilter(
    `${ApiEndPoint.USERS}doctor_personal_detail/`,
    filter,
    clinic ? true : false
  );

  const editDisclaimerMutation = useSecureUpdateItem(
    `${ApiEndPoint.USERS}doctor_personal_detail/`
  );

  const handleSave = () => {
    const payload = {
      action: "patchLoginDoctorDetails",
      backend: "True",
      clinic_id: clinic?.id,
      disclaimer: value,
    };

    editDisclaimerMutation.mutate(
      { data: payload },
      {
        onSuccess: () => {
          setValue("");
          toast.success("Disclaimer added successfully");
        },
        onError: () => {
          toast.error("Error while adding disclaimer");
        },
      }
    );
  };

  const handleCancel = () => {
    setValue("");
    navigate(-1);
  };

  useEffect(() => {
    if (data) {
      setValue(data?.disclaimer);
    }
  }, [data]);

  return (
    <div>
      <div className="mt-5">
        <ReactQuill
          theme="snow"
          value={value}
          onChange={setValue}
          placeholder="Type here disclaimer"
          className="sub-texteditor"
          id="editor"
        />
      </div>
      <div className="flex gap-4 mt-10">
        <button
          className="h-11 w-[156px] rounded-[5px] border border-[#00000033]"
          onClick={handleCancel}
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="h-11 w-[156px] rounded-[5px] border border-[#00000033] bg-[#EBF8EC]"
        >
          {editDisclaimerMutation.isLoading ? <CuSpinner /> : "Save"}
        </button>
      </div>
    </div>
  );
};

export default Disclaimer;
